import React from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { replaceHTMLText } from '../../../helpers/replaceHelper';

class FormbuilderConsent extends React.Component<any, any> {
    getInputLabel = () => {
        let linkLabel = this.props.inputLabel || "I agree to the {url}";
        const url = this.props.link;
        const regex = /{url}/g;
        const splittedArray = linkLabel.split(regex);

        return (
            <React.Fragment>
                {
                    React.Children.toArray(
                        splittedArray.filter((data: any) => data).map((x: any, i: number) => {
                            const isHtmlText = /(.*)?({(u|b|i|link):(.+?)})+?(.*)?/.test(x);
                            const isLastItem = i === splittedArray.length - 1;

                            if (isHtmlText) {
                                x = replaceHTMLText(x);
                            }

                            if (!isLastItem) {
                                return (
                                    <React.Fragment>
                                        {x}<a href={url} rel="noopener noreferrer" target="_blank">Terms and conditions</a>
                                    </React.Fragment>
                                );
                            }

                            return (
                                <React.Fragment>{x}</React.Fragment>
                            );
                        })
                    )
                }
            </React.Fragment>
        );
    }

    render() {
        const { checked, onChange } = this.props;

        return (
            <Form.Field>
                <Checkbox
                    label={
                        <label>
                            <span>
                                {this.getInputLabel()}
                            </span>
                        </label>
                    }
                    checked={checked}
                    onChange={onChange}
                />
            </Form.Field>
        );
    }
}

export default FormbuilderConsent;